import React, { useRef, useState, useEffect } from 'react';

/**
 * Used to init long-polling to grab stauts of CSV generation job.
 * @param {*} callback
 * @param {*} delay
 */
export const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  const [intervalID, setIntervalID] = useState();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay) {
      const id = setInterval(tick, delay);
      setIntervalID(id);
    }

    // Safe-guard. Clear out interval when delay is null.
    if (!delay) {
      clearInterval(intervalID);
    }

    return () => clearInterval(intervalID);
  }, [delay]);
};
